<style>
  .messages-container{
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 999;
  }
</style>

<template>
  <k-loader></k-loader>
  <k-mini-loader></k-mini-loader>
  <div id="panel" class="main-content">
    <div class="messages-container">
      <k-message-handler v-for="(item) in messages" :key="item.messageId"
                         :message="item.message" :message-type="item.messageType" :message-id="item.messageId"></k-message-handler>
    </div>
    <router-view />
  </div>
</template>

<script>
import { ref, provide } from 'vue';
import KMessageHandler from '@/components/message-handler/message-handler.vue';
import KLoader from "@/components/loader/loader.vue";
import KMiniLoader from "@/components/loader/mini-loader.vue";
export default {
  name: 'Home',
  components: {
    KMiniLoader,
    KMessageHandler,
    KLoader
  },
  data(){
    return {
      messages:[]
    }
  },
  setup() {
    //Logica per modal.vue
    const showConfirmButton = ref(false);
    const showCancelButton = ref(false);

    const isModalVisible = ref(false);
    const modalMessage = ref('');
    const modalTitle = ref('');
    const handleModalConfirm = ref(null);

    const showModal = ({ title, message, type, callback}) => {
      modalTitle.value = title || modalTitle.value;
      modalMessage.value = message || modalMessage.value;
      isModalVisible.value = true;

      if(type === "info"){
        showConfirmButton.value = true;
        showCancelButton.value = false;
      }else if(type === "save-close"){
        showConfirmButton.value = true;
        showCancelButton.value = true;
        handleModalConfirm.value = callback
      }

    };
    provide('showModal', showModal);

    // //Logica per configureChartModal.vue
    // const isConfigurationChartModalVisible = ref(false);
    // const configurationData = ref({});
    // const showConfigurationChartModal = ({ configurationDataParam, callback }) => {
    //   console.log("showConfigurationChartModal", configurationDataParam);
    //   isConfigurationChartModalVisible.value = true;
    //   configurationData.value = configurationDataParam;
    //   handleModalConfirm.value = callback || function(){};
    // };
    // provide('showConfigurationChartModal', showConfigurationChartModal);


    //Logica generale per modal
    const handleConfirm = () => {

      if (typeof handleModalConfirm.value === 'function') {
        handleModalConfirm.value();
      }

      closeModal();
    };
    const handleCancel = () => {
      // Logica per il pulsante di annullamento
      closeModal();
    };
    const closeModal = () => {
      handleModalConfirm.value = function(){};
      isModalVisible.value = false;
    };

    return {
      showConfirmButton,
      showCancelButton,
      isModalVisible,
      modalMessage,
      modalTitle,
      showModal,
      closeModal,
      handleConfirm,
      handleCancel,
    };
  },
  created() {
    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === 'addMessage'||mutation.type === 'removeMessage') {
        this.messages=[...state.messageHandler.messages];
      }
    });
  },
}
</script>
